import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

import { Sidebar } from '../../core/services/sidebar';
import { Modal } from '../../core/services/modal';
import { OtpModal } from '../../shared/components/modals/otp-modal/otp-modal';
import { Button } from "../../shared/ui/button/button";
import { PasswordChange } from "../../shared/components/password-change/password-change";
import { Stepper } from "../../shared/components/stepper/stepper";
import { InputField } from "../../shared/ui/input-field/input-field";
import { ModalOptions } from '../../shared/utils/types';
import { BaseModal } from '../../shared/components/modals/base-modal/base-modal';
import { Header } from '../../core/services/header';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  templateUrl: './forgot-password.html',
  styleUrls: ['./forgot-password.css'],
  imports: [
    Button,
    TranslatePipe,
    PasswordChange,
    Stepper,
    CommonModule,
    InputField,
    ReactiveFormsModule
  ]
})
export class ForgotPassword implements OnInit {
  currentStep = 1;
  otpVerified = false;
  userNameForm!: FormGroup;
  email: string = 'z••••@email.com';

  steps = [
    { label: 'FORGOT_PASSWORD.ENTER_USER_NAME' },
    { label: 'FORGOT_PASSWORD.CREATE_NEW_PASSWORD' },
  ];

  constructor(
    private sidebarService: Sidebar,
    private modalService: Modal,
    private fb: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private headerService: Header
  ) { }

  ngOnInit() {
    this.sidebarService.setLinks([{ label: 'SIDEBAR.CANCEL', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }]);

    // Step 1: Username form
    this.userNameForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
    });

    this.headerService.updateConfig({
      showRightSection: false
    })
  }

  /** Step 1: Handle username submission */
  handleStep1() {
    if (this.userNameForm.invalid) return;
    this.getOtpModal();
  }

  /** Step 1: OTP Verification Modal */
  getOtpModal() {
    const otpModalOptions: any = {
      backdropClosable: false,
      showCancelButton: true,
      showConfirmButton: true,
      textConfirmButton: 'OTP_MODAL.VERIFY',
      headerIconPath: 'assets/icons/mail.svg',
      title: 'OTP_MODAL.TITLE_EMAIL',
      message: 'OTP_MODAL.MESSAGE_EMAIL',
      email: this.email,

      onSubmitOtp: (isOtpValid: boolean) => {

        this.otpVerified = isOtpValid;

        if (isOtpValid) {
          this.sidebarService.setLinks([
            { label: 'SIDEBAR.PREVIOUS_SCREEN', action: () => this.goBackStep(), iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' },
            { label: 'SIDEBAR.CANCEL', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }
          ]);
          this.modalService.close();
          this.currentStep = 2;
        } else {
          console.log('Invalid OTP');
        }
      },
    };

    this.modalService.open(OtpModal, otpModalOptions);
  }

  /** Step 2: Back Navigation */
  goBackStep() {
    this.currentStep = 1;
    this.sidebarService.setLinks([{  label: 'SIDEBAR.CANCEL', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }]);
  }

  /** Step 2: Handle password submit event from child */
  handleStep2(passwordData: { newPassword: string; confirmPassword: string }) {
    console.log('Final Password Payload:', passwordData);
    // TODO: Call API here



    this.router.navigate(['/']);
    this.resetSuccessModal()

  }

  resetSuccessModal() {
    const baseModalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: false,
      showConfirmButton: true,
      textConfrimButton: 'FORGOT_PASSWORD.BACK_TO_LOGIN',
      size: 'lg',
      headerIconPath: 'assets/icons/info-check.svg',
      title: 'FORGOT_PASSWORD.RESET_SUCCESS_TITLE',
      message: 'FORGOT_PASSWORD.RESET_SUCCESS_MESSAGE',
      onConfirm: () => {

        this.modalService.close();
      },
    };

    this.modalService.open(BaseModal, baseModalOptions);
  }


  get usernameControl(): FormControl {
    return this.userNameForm.get('username') as FormControl;
  }
}
